import React, { lazy } from 'react';
const CHECKOUT_URL = 'https://betterdailyguides.com/cart/51925795668270:1';
interface ProductSectionProps {
  onBuyClick: (e: React.MouseEvent) => void;
}
export function ProductSection({
  onBuyClick
}: ProductSectionProps) {
  return <section id="product-section" className="bg-[#FAF7F2] py-16 px-5" data-id="element-325">
      <div className="max-w-[900px] mx-auto" data-id="element-326">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-327">
          <div className="rounded-3xl overflow-hidden shadow-2xl" style={{
          aspectRatio: '3/4'
        }} data-id="element-328">
            <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/Recursos_digitales_de_B.E.B.E._365.png?v=1775852000" alt="El Primer Año de tu Bebé — Protocolo B.E.BE 365" width="450" height="600" loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-329" />
          </div>

          <div data-id="element-330">
            <span className="inline-block bg-[rgba(183,110,121,0.1)] text-[#B76E79] text-xs tracking-widest uppercase px-4 py-1.5 rounded-full mb-4 font-sans font-bold" data-id="element-331">
              El Ebook Principal
            </span>

            <h2 className="text-3xl md:text-4xl text-[#3D2B1F] mb-4" data-id="element-332">
              El Primer Año de tu Bebé:
              <br data-id="element-333" />
              Tu Bebé Te Necesita
            </h2>

            <p className="text-base text-[#6B4C3B] font-sans mb-6 leading-relaxed" data-id="element-334">
              Un protocolo de 60 páginas basado en neurociencia aplicada que
              integra los 4 pilares del desarrollo infantil en un sistema de
              alto rendimiento. Diseñado para padres modernos que valoran la
              ciencia, la eficiencia y los resultados reales.
            </p>

            <div className="flex flex-wrap gap-2.5 mb-8" data-id="element-335">
              {['📥 Descarga Inmediata', '⭐ Producto Premium', '📱 Compatible con Móviles', '🌍 En Español'].map((tag, idx) => <span key={idx} className="bg-[rgba(183,110,121,0.1)] text-[#B76E79] text-sm px-3.5 py-1.5 rounded-full font-sans font-bold tracking-wide" data-id="element-336">
                  {tag}
                </span>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}